<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Модификаторы</h1>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-dialog v-model="dialog" max-width="445">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
                  v-bind="attrs"
                  v-on="on"
          >
            Создать модификатор
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ modifierGroup.id ? 'Редактировать модификатор' : 'Создать модификатор'}}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="modificatorForm" v-model="valid">
            <v-text-field
                    label="Внутреннее название"
                    outlined
                    v-model="modifierGroup.working_name"
                    :rules="[rules.required]"
                    required></v-text-field>
            <v-tabs v-model="tab">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :eager="true">
                <v-text-field
                        label="Название"
                        outlined
                        v-model="modifierGroup.name"
                        :rules="[rules.required]"
                        required></v-text-field>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-text-field
                        label="Название"
                        outlined
                        v-model="modifierGroup.name_ua"
                        :rules="[rules.required]"
                        required></v-text-field>
              </v-tab-item>
            </v-tabs-items>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="modifierGroup.id" @click="updateModifierGroup()" :loading="loadingModal">Сохранить</v-btn>
            <v-btn v-else @click="createModifierGroup()" :loading="loadingModal">Добавить</v-btn>
            <v-btn outlined @click="dialog = false">Отменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <modifiers-group-table
              @editModifierGroup="editModal($event)"
              @onDeleteModifierGroup="getDataFromApi"
              @editModifiersInGroup="editModifiersModal($event)"
              v-model="modifiersGroup"
              :loading="loading"
              :disabled="false">

      </modifiers-group-table>
      <modifiers-modal :show-button="false" ref="childComponent" :modifiers-dialog="show" :for-product="false" :modifier-categories="modifiers"></modifiers-modal>
    </v-col>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
  // @ is an alias to /src


  import ModifierService from "../../api/ModifierService";
  import ModifiersGroupTable from "../../components/ModifiersGroupTable";
  import ModifiersModal from "../../components/ModifiersModal";

  export default {
    name: 'ModifierGroupIndex',
    components: {ModifiersGroupTable, ModifiersModal},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      valid: false,
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      loading: true,
      show: false,
      modifiersGroup: [],
      tab: null,
      dialog: false,
      loadingModal: false,
      modifierGroupForModal: {},
      modifiers: [],
      modifierGroup: {
          id: null,
          working_name: '',
          name: '',
          name_ua: ''
      },
    }),
    mounted() {
        this.getDataFromApi();

        ModifierService.listByCategory().then(response => {
            this.modifiers = response.data
        });
    },
    watch: {
    },
    methods: {
      validate(){
        this.$refs.modificatorForm.validate()
        if(this.modifierGroup.name == '' && this.modifierGroup.name_ua != ''){
          this.tab = 0;
        }
        if(this.modifierGroup.name != '' && this.modifierGroup.name_ua == ''){
          this.tab = 1;
        }
      },
      getDataFromApi() {
        this.loading = true

        ModifierService.listGroups({})
          .then(response => {
            this.modifiersGroup = response.data
            this.loading = false
          })
      },
      editModal(item){
          this.modifierGroup.id = item.id;
          this.modifierGroup.name = item.name;
          this.modifierGroup.name_ua = item.name_ua;
          this.modifierGroup.working_name = item.working_name;
          this.dialog = true;
      },
      editModifiersModal(item){
          this.$refs.childComponent.init(item);
          this.modifierGroupForModal = item;
      },
      clearForm(){
          this.modifierGroup.id = null;
          this.modifierGroup.name = '';
          this.modifierGroup.name_ua = '';
          this.modifierGroup.working_name = '';
      },
      createModifierGroup(){
          this.validate();
          if(!this.valid){
            return false;
          }
          this.loadingModal = true;
          ModifierService.createModifierGroup(this.modifierGroup).then(response => {
              this.getDataFromApi();
              this.clearForm();
              this.snackbar = true;
              this.snackbarText = 'Модификатор создан';
              this.snackbarColor = 'success';
          }).catch(error => {
              this.snackbar = true;
              this.snackbarText = 'Ошибка при создании модификатора';
              this.snackbarColor = 'error';
          }).finally(() => {
              this.loadingModal = false;
              this.dialog = false;
          })
      },
      updateModifierGroup(){
          this.validate();
          if(!this.valid){
            return false;
          }
          this.loadingModal = true;
          ModifierService.updateModifierGroup(this.modifierGroup).then(response => {
              this.getDataFromApi();
              this.clearForm();
              this.snackbar = true;
              this.snackbarText = 'Модификатор обновлен';
              this.snackbarColor = 'success';
          }).catch(error => {
              this.snackbar = true;
              this.snackbarText = 'Ошибка при обновлении модификатора';
              this.snackbarColor = 'error';
          }).finally(() => {
              this.dialog = false;
              this.loadingModal = false;
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
